angular.module("app.modalControllers").controller("ModalInstanceController", [
    '$scope',
    '$uibModalInstance',
    '$timeout',
    'userService',
    'userStorage',
    'deepCompare',
    'errorHandler',
    'logger',
    function ($scope, $modalInstance, $timeout, userService, userStorage, deepCompare, errorHandler, logger) {
        $scope.tooltip = {
            name: "",
            userName: "",
            confirmPassword: "",
            password: ""
        };
        $scope.user = angular.copy(userStorage.getUserData());

        $scope.submitEditUserForm = function () {
            var changes = deepCompare.getChanges(angular.copy(userStorage.getUserData()), $scope.user);
            changes.id = $scope.user.id;
            changes.re_password = $scope.my_user_form.confirmPassword.$viewValue;
            userService.editUser({user: changes}).then(
                function (response) {
                    if (response.status == "ok") {
                        userStorage.resetUserData(angular.copy(response.user));
                        logger.logSuccess("Profile has been successfully updated");
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        $scope.close = function () {
            $modalInstance.dismiss('cancel');
        };
    }
]);